module.exports = __webpack_public_path__ + "img/tips.1ab8f6f5.png";